/**
 * @author Harshitha.k
 * @description 
 */

import axios from 'axios';
import './reportConfig.css';
import { v4 as uuidv4 } from 'uuid';
import copy from 'copy-to-clipboard';
import { connect } from 'react-redux';
import { Button, message, Steps } from 'antd';
import { REPORTS } from '../../../commons/api';
import { PlusOutlined } from '@ant-design/icons';
import ApiCustomization from './ApiCustomization';
import React, { useState, useEffect, Fragment } from 'react';
import localStorage from '../../../utils/localStorage';
import WidgetCustomization from './WidgetCustomization';
import ColumnCustomization from './ColumnCustomization';
import ChildTableCustomization from './ChildTableCustomization';
import TableConfigCustomization from './TableConfigCustomization';
import ChildTableApiCustomization from './ChildTableApiCustomization';

const { Step } = Steps;
const ReportTypeComponent = (props) => {
  const [reportType, setReportType] = useState(props.reportType || '');
  // const [reportList, setReportList] = useState([]);
  const [editObj, setEditObj] = useState(props.editObj || {});
  const [currentTab, setCurrentTab] = useState(props.currentTab || '');
  const [reportObject, setReportObject] = useState(props.reportObject || {});
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  const [currentStep, setCurrentStep] = useState(0);
  const [disabled, setDisabled] = useState(false);
  // const uniqueId = uuidv4(); 
  useEffect(() => {
    if (props.editObj !== editObj) {
      setEditObj(props.editObj);
      setReportType(reportType);
      setCurrentTab(props.currentTab);
      setReportObject(reportObject || {});
      setUserProfile(userProfile);
    }
  }, [props]);

  const initalStep = () => setCurrentStep(0);
  const secondStep = () => setCurrentStep(1);

  const addColumn = () => {
    if (editObj) {
      const updatedEditObj = {
        ...editObj,
        columns: [
          ...(editObj['columns'] ? editObj['columns'] : []),
          {
            id: uuidv4(),
            title: 'New Column',
            dataIndex: '',
            key: '',
            width: '100',
            className: ''
          }
        ]
      };

      setEditObj(updatedEditObj);
      setDisabled(false);
    }
  };


  const addChildTableColumn = () => {
    if (editObj) {
      const updatedEditObj = {
        ...editObj,
        childTable: [
          {
            columns: [
              ...(editObj?.childTable?.[0]?.columns || []),
              {
                id: uuidv4(), // Correct UUID import and usage
                title: 'New Column',
                dataIndex: '',
                key: '',
                width: '100',
                className: ''
              }
            ]
          }
        ]
      };

      setEditObj(updatedEditObj);
      setCurrentStep(1);
      setDisabled(false);
    }
  };

  const addTableConfiguration = () => {
    setEditObj(prevEditObj => {
      if (!prevEditObj) return prevEditObj;

      // Default table configuration object
      const defaultTableConfig = {
        bordered: 'true',
        horizontalScroll: 'true',
        tableSize: '10',
        noResultMessage: 'No Records',
        isCursorPointer: 'false',
        downloadXLXS: 'true',
        downloadExcelPayload: {
          portName: 'Excel',
          name: '',
          Consumption: ''
        },
        style: {
          textAlign: 'center',
          fontWeight: 'normal',
          evenRowColor: 'rgb(251, 250, 250)',
          oddRowColor: '#fff'
        }
      };

      return {
        ...prevEditObj,
        tableConfiguration: prevEditObj.tableConfiguration 
          ? { ...prevEditObj.tableConfiguration }
          : defaultTableConfig
      };
    });

    setCurrentStep(2);
    setDisabled(false);
  };

  const addApi = () => {
    setEditObj(prevEditObj => {
      if (!prevEditObj) return prevEditObj;

      const updatedEditObj = prevEditObj['api'] 
        ? {
            ...prevEditObj,
            api: prevEditObj['api']
          }
        : {
            ...prevEditObj,
            api: {
              ...(prevEditObj['api'] || []),
              uri: 'uri',
              method: 'POST',
              payload: {},
              query: ''
            }
          };

      return updatedEditObj;
    });

    setCurrentStep(3);
    setDisabled(false);
  };

  const addChildTableApi = () => {
    if (editObj) {
      const updatedEditObj = { 
        ...editObj,
        childTable: [
          {
            columns: [
              {
                ...(editObj.childTable && 
                   editObj.childTable[0]?.columns 
                   ? editObj.childTable[0].columns 
                   : [])
              }
            ],
            api: editObj.childTable && editObj.childTable[0]?.api 
              ? editObj.childTable[0].api 
              : {
                  uri: 'uri',
                  method: 'POST',
                  payload: {},
                  query: ''
                }
          }
        ]
      };

      setEditObj(updatedEditObj);
      setCurrentStep(5);
      setDisabled(true);
    }
  };

  const addSelectionWidget = () => {
    if (editObj) {
      const updatedEditObj = {
        ...editObj,
        selectionWidget: editObj['selectionWidget'] 
          ? {
              ...editObj['selectionWidget']
            }
          : {
              displayWidget: 'false',
              widget: 'month-picker',
              placeholder: '',
              format: 'YYYYY-MMMM',
              payload: {}
            }
      };

      setEditObj(updatedEditObj);
      setCurrentStep(4);
      setDisabled(false);
    }
  };

  const jsonSaveObject = (columns, key) => {
    let updatedEditObj = { ...editObj };

    if (key === 'columns') {
      updatedEditObj.columns = [...(columns ? columns : [])];
    } else if (key === 'childTable') {
      updatedEditObj.childTable = [{ columns: [...(columns ? columns : [])] }];
    } else if (key === 'childTableApi') {
      updatedEditObj.childTable = [
        {
          columns: [
            ...(updatedEditObj['childTable'][0]['columns'] ? updatedEditObj['childTable'][0]['columns'] : [])
          ],
          api: columns ? columns : {}
        }
      ];
    } else {
      updatedEditObj[key] = { ...(columns ? columns : {}) };
    }

    setEditObj(updatedEditObj);
  };

  const generateJSON = () => {
    copy(JSON.stringify(editObj));
    message.success('Copied to clipboard');
  };

  const updateReportJSON = () => {
    let payload = {
      JSON: editObj,
      tabName: props.tabName,
      reportType: props.reportType,
      reportName: props.reportName,
      createdBy: '',
      type: 'update'
    };

    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const deviceTypeObject = {
      method: 'POST',
      url: `${REPORTS.InsertJSON}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    axios(deviceTypeObject)
      .then(() => {
        message.success('ReportJSON Updated Successfully');
        props.updatefunction(props.reportObject);
      })
      .catch(() => {});
  };

  const nextTab = (current) => {
    let newStep = current + 1;
    if (newStep === 0) {
      addColumn();
    } else if (newStep === 1) {
      addChildTableColumn();
    } else if (newStep === 2) {
      addTableConfiguration();
    } else if (newStep === 3) {
      addApi();
    } else if (newStep === 4) {
      addSelectionWidget();
    } else if (newStep === 5) {
      addChildTableApi();
    }
    setCurrentStep(newStep);
  };

  const previousTab = (current) => {
    let newStep = current - 1;
    setCurrentStep(newStep);
  };

  const steps = [
    {
      title: 'Columns',
      onClick: initalStep,
      content: (
        <div>
          <Button
            onClick={addColumn}
            title={'Add Column'}
            key={'Add Column'}
            type="primary"
            style={{ marginLeft: '5%', marginTop: '2%' }}
          >
            Add Columns
          </Button>
        </div>
      )
    },
    {
      title: 'ChildTable',
      onClick: secondStep,
      content: (
        <div>
          <Button
            onClick={addChildTableColumn}
            title={'Add ChildTable'}
            key={'Add ChildTable'}
            type="primary"
            style={{ marginLeft: '5%', marginTop: '2%' }}
          >
            <PlusOutlined /> Add ChildTable
          </Button>
        </div>
      )
    },
    {
      title: 'TableConfiguration',
      onClick: addTableConfiguration,
      content: addTableConfiguration
    },
    {
      title: 'Api',
      onClick: addApi,
      content: addApi
    },
    {
      title: 'SelectionWidget',
      onClick: addSelectionWidget,
      content : addSelectionWidget
    }
  ];

  if (
    editObj &&
    editObj['childTable'] &&
    editObj['childTable'][0] &&
    editObj['childTable'][0]['columns'].length > 0
  ) {
    steps.push({
      title: 'ChildTableApi',
      onClick: addChildTableApi,
      content: addChildTableApi
    });
  }

  return (
    <div style={{ padding: '30px' }}>
      <div>
        {editObj && Object.keys(editObj).length > 0 ? (
          <Fragment>
            <Steps
              type="navigation"
              style={{ cursor: 'pointer' }}
              current={currentStep}
            >
              {steps && Array.isArray (steps) && steps.map((item) => (
                <Step key={item.title} title={item.title} onClick={item.onClick} />
              ))}
            </Steps>
            <div className="configDiv" style={{ minHeight: '700px' }}>
              {steps  && steps[currentStep] && steps[currentStep].content ? steps[currentStep].content :''}

              {editObj && editObj['columns'] && currentStep === 0 ? (
                <div>
                  <ColumnCustomization
                  columnsProperties={editObj['columns']}
                  jsonSaveObject={jsonSaveObject}
                />
                </div>
              ) : null}
              {editObj && editObj['childTable'] && currentStep === 1 ? (
                <div>
                  <ChildTableCustomization
                  columnsProperties={
                    editObj && editObj['childTable'] && editObj['childTable'][0].columns
                  }
                  jsonSaveObject={(data) => jsonSaveObject(data, 'childTable')}
                />
                </div>
              ) : null}
              {editObj && editObj['tableConfiguration'] && currentStep === 2 ? (
               <div>
                 <TableConfigCustomization
                  tableProperties={editObj['tableConfiguration']}
                  jsonSaveObject={jsonSaveObject}
                />
                </div>
              ) : null}
              {editObj && editObj['api'] && currentStep === 3 ? (
                <div>
                <ApiCustomization
                  apiProperties={editObj['api']}
                  jsonSaveObject={jsonSaveObject}
                  currentTab={currentTab}
                />
                </div>
              ) : null}
              {editObj && editObj['selectionWidget'] && currentStep === 4 ? (
                <div>
                <WidgetCustomization
                  widgetProperties={editObj['selectionWidget']}
                  jsonSaveObject={jsonSaveObject}
                  currentTab={currentTab}
                />
                </div>
              ) : null}
              {editObj &&
                editObj['childTable'] &&
                editObj.childTable[0].api &&
                currentStep === 5 ? (
                  <div>
                <ChildTableApiCustomization
                  apiProperties={
                    editObj && editObj['childTable'] && editObj['childTable'][0].api
                  }
                  jsonSaveObject={jsonSaveObject}
                />
                </div>
              ) : null}
            </div>
          </Fragment>
        ) : null}

        {currentStep === 0 ? (
          <div>
            <Button
              style={{ marginTop: '2%', marginLeft: '80%' }}
              type="primary"
              onClick={() => nextTab(currentStep)}
            >
              NEXT
            </Button>
          </div>
        ) : (
          <div>
            <Button
              style={{ marginTop: '2%', marginLeft: '70%' }}
              type="primary"
              onClick={() => previousTab(currentStep)}
            >
              PREVIOUS
            </Button>
            <Button
              disabled={disabled}
              style={{ marginTop: '2%', marginLeft: '2%' }}
              type="primary"
              onClick={() => nextTab(currentStep)}
            >
              NEXT
            </Button>
          </div>
        )}

        {(editObj && editObj['columns']) ||
          (editObj && editObj['childTable']) ||
          editObj['tableConfiguration'] ||
          editObj['api'] ||
          editObj['selectionWidget'] ? (
          <div>
            {currentTab === 'Generate JSON' ? (
              <Button type="primary" style={{ marginTop: '2px' }} onClick={generateJSON}>
                Generate JSON
              </Button>
            ) : null}
            {currentTab === 'Edit Report JSON' ? (
              <Button style={{ marginTop: '2%' }} onClick={updateReportJSON} type="primary">
                Save Report JSON
              </Button>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userProfile: state.LayoutReducer.loggedInProfile
  };
};

export default connect(mapStateToProps)(ReportTypeComponent);